/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
    PersonaToJSONTyped,
} from './Persona';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface Participant
 */
export interface Participant {
    /**
     * Unique identifier of the participant
     * @type {string}
     * @memberof Participant
     */
    id: string;
    /**
     * The persona associated with this participant
     * @type {Persona}
     * @memberof Participant
     */
    member: Persona;
    /**
     * The role of this participant in the channel
     * @type {string}
     * @memberof Participant
     */
    role: ParticipantRoleEnum;
    /**
     * Current status of this participant in the channel
     * @type {string}
     * @memberof Participant
     */
    status: ParticipantStatusEnum;
    /**
     * Timestamp when this participant was last seen in the channel
     * @type {Date}
     * @memberof Participant
     */
    lastSeen: Date;
    /**
     * The last message this participant has read, if any
     * @type {ChatMessage}
     * @memberof Participant
     */
    lastReadMessage?: ChatMessage;
}


/**
 * @export
 */
export const ParticipantRoleEnum = {
    User: 'USER',
    Agent: 'AGENT',
    System: 'SYSTEM',
    AiBot: 'AI_BOT',
    AutomationBot: 'AUTOMATION_BOT'
} as const;
export type ParticipantRoleEnum = typeof ParticipantRoleEnum[keyof typeof ParticipantRoleEnum];

/**
 * @export
 */
export const ParticipantStatusEnum = {
    Active: 'ACTIVE',
    Left: 'LEFT'
} as const;
export type ParticipantStatusEnum = typeof ParticipantStatusEnum[keyof typeof ParticipantStatusEnum];


/**
 * Check if a given object implements the Participant interface.
 */
export function instanceOfParticipant(value: object): value is Participant {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('member' in value) || value['member'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('lastSeen' in value) || value['lastSeen'] === undefined) return false;
    return true;
}

export function ParticipantFromJSON(json: any): Participant {
    return ParticipantFromJSONTyped(json, false);
}

export function ParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): Participant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'member': PersonaFromJSON(json['member']),
        'role': json['role'],
        'status': json['status'],
        'lastSeen': (new Date(json['lastSeen'])),
        'lastReadMessage': json['lastReadMessage'] == null ? undefined : ChatMessageFromJSON(json['lastReadMessage']),
    };
}

export function ParticipantToJSON(json: any): Participant {
    return ParticipantToJSONTyped(json, false);
}

export function ParticipantToJSONTyped(value?: Participant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'member': PersonaToJSON(value['member']),
        'role': value['role'],
        'status': value['status'],
        'lastSeen': value['lastSeen'].toISOString(),
        'lastReadMessage': ChatMessageToJSON(value['lastReadMessage']),
    };
}

